import dayjs from "dayjs";
import {
  CALENDAR_RESERVATION_TYPE,
  DATE_FORMAT,
} from "./constants";

export const formatDateString = (dateString: string) => {
  return dateString ? dayjs(dateString).format(DATE_FORMAT) : "---";
};

export const formatEnumValue = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const getWorkspaceSlotTime = (startTime: string): string => {
  const date = new Date(startTime);
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

export function getWorkspaceSlotDuration(
  startTime: string,
  endTime: string
): string {
  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffMs = end.getTime() - start.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  if (diffMinutes >= 60) {
    const hours = Math.floor(diffMinutes / 60);
    const minutes = diffMinutes % 60;
    return minutes > 0
      ? `${hours} hour${hours > 1 ? "s" : ""} ${minutes} minute${
          minutes > 1 ? "s" : ""
        }`
      : `${hours} hour${hours > 1 ? "s" : ""}`;
  } else {
    return `${diffMinutes} minute${diffMinutes !== 1 ? "s" : ""}`;
  }
}

export function formatWorkspaceTimeRange(
  startISO: string,
  endISO: string
): string {
  const start = new Date(startISO);
  const end = new Date(endISO);
  const weekday = start.toLocaleDateString("en-US", { weekday: "short" });
  const formatHourMin = (date: Date) =>
    date
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .replace(/ (AM|PM)/, "");
  const endAmPm =
    end
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      })
      .match(/AM|PM/i)?.[0] || "";
  return `${weekday}, ${formatHourMin(start)} - ${formatHourMin(
    end
  )} ${endAmPm}`;
}

export function isPaidSlot(type: string): boolean {
  return type !== CALENDAR_RESERVATION_TYPE.MEETING_ROOMS;
}

export function separateLastWord(text: string): {
  mainString: string;
  lastWord: string | null;
} {
  text = text.trim();
  const lastSpaceIndex = text.lastIndexOf(" ");

  if (lastSpaceIndex === -1) {
    return { mainString: "", lastWord: text };
  }

  const mainString = text.substring(0, lastSpaceIndex);
  const lastWord = text.substring(lastSpaceIndex + 1);

  return { mainString, lastWord };
}
export interface MembershipPlanType {
  title: string;
  subTitle: string;
  creditType?: string;
}

